<template>
  <v-menu v-model="open" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" v-show="show">
        Rückruf vereinbaren
      </v-btn>
    </template>
    <div class="baufi-picker">
      <v-card elevation="5" class="baufi-picker-inner">
        <v-date-picker
          class="mt-4"
          full-width
          locale="de-de"
          :first-day-of-week="1"
          v-model="picker"
        ></v-date-picker>
        <div id="time">
          <v-text-field
            id="time-input"
            v-model="time"
            :counter="5"
            :rules="timeRules"
            outlined
            placeholder="Uhrzeit in dem format eingeben 00:00"
            autofocus
            prepend-inner-icon="mdi-clock"
            dense
            required
          ></v-text-field>
          <v-btn color="success" depressed block @click="new_termin"
            >Termin vereinbaren</v-btn
          >
        </div>
      </v-card>
    </div>
  </v-menu>
</template>
<script>
import { mapGetters } from 'vuex';
import instance from '../../lib/api';

export default {
  name: 'BauFi-Picker',
  props: {
    show: Boolean,
    dialog: Boolean,
    lead_id: Number,
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  data() {
    return {
      picker: new Date().toISOString().substr(0, 10),
      time: '',
      timeRules: [
        (v) => !!v || 'Zeit angabe ist benötigt',
        (v) =>
          /(\d{2})[:](\d{2})/.test(v) ||
          'Die Zeitangbe ist ungeültigt beispiel zeitangbe: 12:14',
        (v) => v.length <= 5 || 'Die Zeit darf maximal nur 5 zeichen haben.',
      ],
      open: false,
    };
  },
  methods: {
    new_termin() {
      const time = this.time.split(':');
      // german date format to utc
      const seconds = Number(time[0] - 1) * 3600 + Number(time[1] - 10) * 60;
      const t = this;
      instance
        .post('/leads/update/termin', {
          termin: this.picker,
          time: seconds,
          lead_id: this.lead_id,
        })
        .then(() => {
          this.$emit('close');
          instance.post('/history', {
            lead_id: t.lead_id,
            action: `"Termin wurde vereinbart: Termin: "Datum: ${this.picker} Uhrzeit: ${this.time}"`,
            salesperson: this.user.data.email,
          });
          this.open = !this.open;
        });
    },
  },
};
</script>
<style lang="scss">
.baufi-picker {
  max-width: 25vw;

  #time {
    padding: 12px;
  }
}
</style>
